// Generated on 2026-07-13T21:59:04.235Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "52012"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "38518"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "37253"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "28791"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "25916"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "24337"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "23873"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "22701"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "20359"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "19249"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "18917"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "16182"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "14671"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "12663"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "12654"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "12552"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "11888"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "11571"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "11059"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "10097"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "9977"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "9907"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "8800"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "8710"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "8602"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "8290"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "8276"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "8118"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "8017"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "7274"
  }
];

export default preloadedProductsTopBrands;
